import { FunctionComponent } from "react";
import { StyledCol } from "./col.styles";

interface ColProps {
  children?: any;
  className?: string;
  flex?: 0 | 1;
}

const Col: FunctionComponent<ColProps> = ({
  children,
  className,
  flex = 1,
}) => {
  return (
    <StyledCol $flex={flex} className={className}>
      {children}
    </StyledCol>
  );
};

export default Col;
